<template>
  <div class="sweep">
    <div class="isDrug" v-if="isDrug">
      <div class="drug_name">{{drug.name}}</div>
      <div class="drug_specification">{{drug.specification}}</div>
      <div class="sweep_btn" @click="goToFill()">我要复诊开药</div>
      <div class="drug_no">药品不对?请点击反馈</div>
    </div>
    <div class="isDrug" v-if="!isDrug">
        <img src="../images/add.png" alt="">
        <div class="sorry_text">抱歉 未找到相关药品</div>
        <div class="sweep_no_btn">去问诊</div>
        <div class="sweep_no_btn" @click="again_sweep">重新扫码</div>
    </div>
  </div>
</template>

<script>
import {getUrlKey,setCookie} from '@/utils/common.js';
import { Toast, Dialog } from "vant";
import { GetDrugByUpcCode } from "@/utils/api.js";
export default {
  data() {
    return {
      isDrug: true, //扫码结果 控制显示内容
      drug: {
        name: "恩替咖位分享篇",
        specification: "0.5mg×7粒×2板/盒"
      }
    };
  },
  methods:{
    goToFill(){
      console.log(111);
      
    },
    again_sweep(){
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      //console.log("appToken过期，开始调用app方法")
      if (isAndroid) {
        //console.log("调用了安卓的方法")
        window.jsObj.cameraScan(2);
        //console.log("进入catch")
      } else if (isiOS) {
        //console.log("调用了IOS的方法")
        window.webkit.messageHandlers.cameraScan.postMessage(2);
        //console.log("进入catch")
      }
    }
  },
  mounted(){
    if(getUrlKey('upcCode')){
      
      let upcCode = getUrlKey('upcCode')
      GetDrugByUpcCode({
        upcCode
      }).then(res =>{
        if(res.code == 0){
          this.isDrug = true
          console.log(res.data);
          this.drug.name = res.data.DrugName 
          this.drug.specification = res.data.Specs 
          setCookie('Druglist',res.data)
        } else {
          this.isDrug = false
        }
      })
    }else {
      this.isDrug = false
    }
    window.cameraScanResult = function(res){
            Dialog.alert({
            title: '开启扫码',
            })
            this.$router.push('/sweep_code_results')
        }
  }
};
</script>

<style scoped>
.sweep {
  text-align: center;
}
.drug_name {
  font-size: 22px;
  padding: 30px 0 15px 0;
}
.drug_specification {
}
.isDrug img {
    width: 20%;
}
.sweep_btn,.sweep_no_btn {
  width: 80%;
  margin: 100px auto 15px;
  border-radius: 23px;
  background: skyblue;
  color: #000;
  font-size: 16px;
  height: 45px;
  line-height: 45px;
}
</style>